<!--
 * @Author: Zyr
 * @Date: 2021-01-07 17:43:53
 * @LastEditTime: 2021-01-10 19:01:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\components\Account\comMainInfo.vue
-->

<template>
    <div class="card-fa-div">
        <el-card class="box-card" style="width: 100%; height:750px;">
        <el-row>
            <h1 style="float:left">修改密码</h1>
        </el-row>
        <div style="font-size:20px"> 
            <el-row>
                <el-col :span="16" :offset="5">
                    <el-form :class="[msgIsShow?'register-form-right':'register-form-center']"
                        :model="ruleForm2"
                        :rules="rules2"
                        ref="ruleForm2">
                        <div style="margin-top:30px;margin-bottom:20px">
                            <h3 style="text-align:left;color:white;margin:0;font-size:22px;">欢迎注册</h3>          
                        </div>
                        <el-form-item prop="username">
                            <el-input class="login-input" v-model="ruleForm2.username" auto-complete="off" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item prop="tel">
                            <el-input class="login-input" v-model="ruleForm2.tel" auto-complete="off" placeholder="请输入邮箱号"></el-input>
                        </el-form-item>
                        <el-form-item prop="smscode" class="code">
                            <el-input class="login-input" v-model="ruleForm2.smscode" placeholder="验证码"></el-input>
                        <el-button type="primary" :disabled='isDisabled' @click="sendCode">{{buttonText}}</el-button>
                        </el-form-item>
                        <el-form-item prop="pass">
                            <el-input type="password" class="login-input"  v-model="ruleForm2.pass" auto-complete="off" placeholder="输入密码"></el-input>
                        </el-form-item>
                        <el-form-item prop="checkPass">
                            <el-input type="password" class="login-input" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="确认密码"></el-input>
                        </el-form-item>
                        <div style="margin-top:1.5rem;">
                            <el-button class="loginButton" 
                            type="primary" @click="submitForm('ruleForm2')">注册</el-button>
                        </div>
                    </el-form>
                </el-col>
            </el-row>    
        </div>
      </el-card>
    </div>


</template>

<script>


export default {
    name:'comChangePassword',
    data() {
        let checkUsername = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入用户名'))
        } else {
            callback()
        }
        }
        // <!--验证邮箱号是否合法-->
        let checkTel = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入邮箱号'))
        } else if (!this.checkMobile(value)) {
            callback(new Error('邮箱号不合法'))
        } else {
            callback()
        }
        }
        //  <!--验证码是否为空-->
        let checkSmscode = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入验证码'))
        } else {
            callback()
        }
        }
        // <!--验证密码-->
        let validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入密码'))
        } else {
            if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass')
            }
            callback()
        }
        }
        // <!--二次验证密码-->
        let validatePass2 = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请再次输入密码'))
        } else if (value !== this.ruleForm2.pass) {
            callback(new Error('两次输入密码不一致!'))
        } else {
            callback()
        }
        }
        return {
        ruleForm2: {
            username: '',
            pass: '',
            checkPass: '',
            tel: '',
            smscode: '',
        },
        rules2: {
            username: [{ validator: checkUsername, trigger: 'change' }],
            pass: [{ validator: validatePass, trigger: 'change' }],
            checkPass: [{ validator: validatePass2, trigger: 'change' }],
            tel: [{ validator: checkTel, trigger: 'change' }],
            smscode: [{ validator: checkSmscode, trigger: 'change' }],
        },
        buttonText: '发送验证码',
        isDisabled: false, // 是否禁止点击发送验证码按钮
        flag: true,

        //文字是否展示
        msgIsShow: true,
        screenWidth: document.body.clientWidth,
        }
    },

  components: {
    
  },

    mounted(){
      
    },

    methods:{
        

    }

}
</script>

<style scoped>

.code >>> .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/Account/comChangePassword.vue